import { render } from "./ProyectoForm.vue?vue&type=template&id=2b9967da&scoped=true"
import script from "./ProyectoForm.vue?vue&type=script&lang=js"
export * from "./ProyectoForm.vue?vue&type=script&lang=js"

import "./ProyectoForm.vue?vue&type=style&index=0&id=2b9967da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9967da"]])

export default __exports__